import React, { Component } from "react";
import "./assets/stylesheet/style.css";
import SurveyWrapper from "./components/SurveyWrapper";
import Slide1 from "./components/Slide1";
import Slide2_1 from "./components/Slide2_1";
import AdvisorInterviewQuestion from "./components/AdvisorInterviewQuestion";
import Slide2_2 from "./components/Slide2_2";
import Slide2_3 from "./components/Slide2_3";
import Slide2_4 from "./components/Slide2_4";
import CustomerSatisfaction from "./components/CustomerSatisfaction";
import Thankyou from "./components/thankyou";
import ErrorBoundary from "./components/ErrorBoundary";
import api from "./service";
import axios from "axios";
import { setUserId, track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "./config/amplitude";
import { setSentryUser, setSentryTags, setSentryContext, captureException } from "./config/sentry";
import {
  STEPS,
  STATUS,
  QUESTION_IDS,
  ANSWER_IDS,
  STRINGS,
  GOOGLE_REVIEW_URL,
} from "./constants";

export default class App extends Component {
  //  slide2.1
  state = {
    step: STEPS.INITIAL,
    date: "",
    requestId: "",
    medium: "sms",
    status: "",
    questionId1: "",
    advisorMatches: "",

    //slide 2.1.1
    interviewany: "",
    options1: [],
    othersInfo: "",

    // slide 2.1
    optradio1: "",
    sellerId: "",
    others: "",
    sellerName: "",

    // slide 2.2
    decision: "",
    distance: "",
    advisorpokenTo: [],
    checknon: "",

    //slide2.3
    location: "",
    communicating: "",
    decision_making: "",
    communicatingyes: [],

    //slide2.4
    hiring: "",
    hiringothers: "",
    assist_with: "",
    checknon1: "",
    selectspokenTo: [],
  };

  // Utility function to handle checkbox selection logic
  handleCheckboxSelection = (config) => {
    const {
      event,
      stateKey,
      sellerName,
      specialValue,
      specialStateKey,
      othersInfo
    } = config;

    let sellerNm = sellerName || event.target.name;
    let selected = [...this.state[stateKey]]; // Create a copy to avoid mutation
    var id = event.target.value;

    // Handle special values (NONE_OF_THE_ABOVE, OTHER)
    if (specialValue && id === specialValue) {
      if (specialStateKey) {
        if (event.target.checked) {
          this.setState({ [specialStateKey]: specialValue });
        } else {
          this.setState({ [specialStateKey]: "" });
        }
      }
    }

    // Find existing selections
    let find = selected.indexOf(sellerNm + "(Sid-" + id + ")");
    let specialFind = specialValue ? selected.indexOf(specialValue) : -1;
    let othersFind = othersInfo ? selected.indexOf("other-" + othersInfo) : -1;

    // Handle deselection
    if (find > -1 || specialFind > -1 || othersFind > -1) {
      if (find > -1) {
        selected.splice(find, 1);
      }
    } else {
      // Handle selection
      if (specialValue && id === specialValue) {
        if (specialValue === STRINGS.NONE_OF_THE_ABOVE) {
          selected.length = 0; // Clear all selections
          selected.push(specialValue);
        } else {
          selected.push(id);
        }
      } else {
        // Remove special value if selecting regular option
        if (specialValue && specialFind > -1) {
          selected.splice(specialFind, 1);
        }
        selected.push(sellerNm + "(Sid-" + id + ")");
      }
    }

    // Update state with callback for logging
    this.setState(
      { [stateKey]: selected },
      () => console.log("checkbox", this.state[stateKey])
    );
  };

  handlecheckbox4 = event => {
    this.handleCheckboxSelection({
      event,
      stateKey: 'selectspokenTo',
      specialValue: STRINGS.NONE_OF_THE_ABOVE,
      specialStateKey: 'checknon1'
    });
  };

  handlecheckbox1 = event => {
    this.handleCheckboxSelection({
      event,
      stateKey: 'options1',
      specialValue: STRINGS.OTHER,
      othersInfo: this.state.othersInfo
    });
  };

  handlecheckbox3 = input => event => {
    this.handleCheckboxSelection({
      event,
      stateKey: 'communicatingyes',
      sellerName: input
    });
  };

  handlecheckbox2 = event => {
    this.handleCheckboxSelection({
      event,
      stateKey: 'advisorpokenTo',
      specialValue: STRINGS.NONE_OF_THE_ABOVE,
      specialStateKey: 'checknon'
    });
  };

  handleForm = () => event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleRadio = input => e => {
    this.setState({ [e.target.name]: input });
    this.setState({ sellerName: e.target.value });
  };

  nextStep = () => {
    const { step } = this.state;

    // Track step progression
    track(AMPLITUDE_EVENTS.SURVEY_STEP_COMPLETED, {
      step: step,
      requestId: this.state.requestId,
      medium: this.state.medium,
    });

    this.setState({
      step: step + 1,
    });
  };

  prevStep = () => {
    const { step } = this.state;

    // Track step navigation back
    track(AMPLITUDE_EVENTS.SURVEY_STEP_NAVIGATED_BACK, {
      step: step,
      requestId: this.state.requestId,
      medium: this.state.medium,
    });

    this.setState({ step: step - 1 });
  };

  componentDidMount() {
    const today = new Date().toISOString().split("T")[0];
    this.setState({ date: today });

    var url_string = window.location.href;
    var url = new URL(url_string);
    var req = url.searchParams.get("req");
    var medium = url.searchParams.get("medium");

    // Set userId for Amplitude (already initialized in index.js)
    setUserId(req);

    // Set up Sentry user context
    if (req) {
      setSentryUser(req, {
        medium: medium,
        requestId: req,
      });

      // Set additional Sentry tags and context
      setSentryTags({
        medium: medium,
        surveyType: "consumer_survey",
      });

      setSentryContext("survey", {
        requestId: req,
        medium: medium,
        startDate: today,
        url: url_string,
      });
    }

    // Track survey start
    track(AMPLITUDE_EVENTS.SURVEY_STARTED, {
      request_id: req,
      medium_type: medium,
    });

    // Set requestId and medium in state
    this.setState({
      requestId: req,
      medium: medium === "email" ? "email" : "sms",
    });
  }

  handleClick = (input, value) => e => {
    this.setState({ [input]: value });
    this.CreateObj1(value);
  };

  CreateObj1 = event => {
    const obj1 = {
      requestid: this.state.requestId,
      medium: this.state.medium,
      answerId: event,
      questionId: QUESTION_IDS.ADVISOR_REQUEST_STATUS,
      responseInfo: STRINGS.NA,
      createDt: this.state.date,
    };
    this.handleSubmit(obj1);
  };

  // Utility function to handle multiple API submissions sequentially
  submitSurveyResponses = async (responseObjects) => {
    const stepNames = ["first", "second", "third", "fourth", "fifth"];

    for (let i = 0; i < responseObjects.length; i++) {
      const obj = responseObjects[i];

      console.log(obj);

      // Track answer submission
      track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMITTED, {
        questionId: obj.questionId,
        answerId: obj.answerId,
        requestId: obj.requestid,
        medium: obj.medium,
      });

      const config = {
        method: "post",
        url: api.submit_response,
        headers: {
          // "Content-Type": "application/json"
        },
        data: obj,
      };

      try {
        const response = await axios(config);
        console.log(response);

        // Log success message for multiple submissions
        if (responseObjects.length > 1) {
          console.log(`${stepNames[i]} answers saved`);
        }
      } catch (error) {
        console.log(error);

        // Log failure message for multiple submissions
        if (responseObjects.length > 1) {
          console.log(`Failed saving ${stepNames[i]} answer`);
        }

        // Capture error in Sentry with context
        captureException(error, {
          survey: {
            requestId: obj.requestid,
            medium: obj.medium,
            questionId: obj.questionId,
            answerId: obj.answerId,
            step: responseObjects.length > 1 ? `${stepNames[i]}_object_submission` : undefined,
            submissionAttempt: i + 1,
            totalSubmissions: responseObjects.length,
          },
          api: {
            url: api.submit_response,
            method: "post",
            data: obj,
          },
        });

        // Track submission error
        track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMISSION_ERROR, {
          questionId: obj.questionId,
          answerId: obj.answerId,
          error: error.message,
          requestId: obj.requestid,
          step: responseObjects.length > 1 ? `${stepNames[i]}_object_submission` : undefined,
        });

        // Re-throw error to stop further submissions
        throw error;
      }
    }
  };

  // Handle final step logic (5-star rating check and Google redirect)
  handleFinalStep = (finalAnswerId) => {
    // Track survey completion
    track(AMPLITUDE_EVENTS.SURVEY_COMPLETED, {
      requestId: this.state.requestId,
      medium: this.state.medium,
      finalAnswerId: finalAnswerId,
    });

    // Check if user gave 5-star rating (value "54" for recommend question)
    if (finalAnswerId === ANSWER_IDS.RECOMMEND_5) {
      // Track 5-star rating
      track(AMPLITUDE_EVENTS.FIVE_STAR_RATING_GIVEN, {
        requestId: this.state.requestId,
        medium: this.state.medium,
      });
      // Redirect to Google review page
      window.location.href = GOOGLE_REVIEW_URL;
    } else {
      // Track non-5-star rating
      track(AMPLITUDE_EVENTS.NON_FIVE_STAR_RATING_GIVEN, {
        requestId: this.state.requestId,
        medium: this.state.medium,
        rating: finalAnswerId,
      });
      // Show thank you page for non-5-star ratings
      this.nextStep();
    }
  };

  handleSubmit = obj1 => {
    this.submitSurveyResponses([obj1])
      .then(() => {
        this.nextStep(this);
      })
      .catch(error => {
        // Error already logged in submitSurveyResponses
      });
  };

  handleSubmit2 = (obj1, obj2) => {
    this.submitSurveyResponses([obj1, obj2])
      .then(() => {
        this.nextStep(this);
      })
      .catch(error => {
        // Error already logged in submitSurveyResponses
      });
  };

  handleSubmit3 = (obj1, obj2, obj3) => {
    this.submitSurveyResponses([obj1, obj2, obj3])
      .then(() => {
        this.nextStep(this);
      })
      .catch(error => {
        // Error already logged in submitSurveyResponses
      });
  };

  handleSubmit5 = (obj1, obj2, obj3, obj4, obj5) => {
    this.submitSurveyResponses([obj1, obj2, obj3, obj4, obj5])
      .then(() => {
        // Handle final step logic after successful API submissions
        this.handleFinalStep(obj5.answerId);
      })
      .catch(error => {
        // Error already logged in submitSurveyResponses
      });
  };

  render() {
    const { step } = this.state;
    return (
      <ErrorBoundary componentName="App">
        {this.renderSurveyContent(step)}
      </ErrorBoundary>
    );
  }

  renderSurveyContent(step) {
    switch (step) {
      case STEPS.INITIAL:
        return (
          <SurveyWrapper values={this.state}>
            <Slide1
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              handleClick={this.handleClick}
              values={this.state}
            />
          </SurveyWrapper>
        );
      case STEPS.SECOND:
        return (
          <SurveyWrapper values={this.state}>
            {this.state.status === STATUS.FOUND_ADVISOR ? (
              <Slide2_1
                handleInput={this.handleForm}
                handleSubmit2={this.handleSubmit2}
                prevStep={this.prevStep}
                nextStep={this.nextStep}
                handleRadio={this.handleRadio}
                values={this.state}
              />
            ) : this.state.status === STATUS.INTERVIEWING ? (
              <Slide2_2
                handlecheckbox2={this.handlecheckbox2}
                handleInput={this.handleForm}
                handleSubmit3={this.handleSubmit3}
                nextStep={this.nextStep}
                prevStep={this.prevStep}
                handleChange={this.handleChange}
                values={this.state}
              />
            ) : this.state.status === STATUS.NEED_MORE_TIME ? (
              <Slide2_3
                handlecheckbox3={this.handlecheckbox3}
                handleInput={this.handleForm}
                handleSubmit3={this.handleSubmit3}
                nextStep={this.nextStep}
                prevStep={this.prevStep}
                values={this.state}
              />
            ) : this.state.status === STATUS.OTHER ? (
              <Slide2_4
                handlecheckbox4={this.handlecheckbox4}
                handleInput={this.handleForm}
                values={this.state}
                handleSubmit3={this.handleSubmit3}
                prevStep={this.prevStep}
              />
            ) : null}
          </SurveyWrapper>
        );
      case STEPS.THIRD:
        return (
          <SurveyWrapper values={this.state}>
            {this.state.status === STATUS.FOUND_ADVISOR ? (
              <AdvisorInterviewQuestion
                handlecheckbox1={this.handlecheckbox1}
                handleSubmit={this.handleSubmit}
                prevStep={this.prevStep}
                nextStep={this.nextStep}
                handleInput={this.handleForm}
                values={this.state}
              />
            ) : (
              <CustomerSatisfaction
                handleSubmit5={this.handleSubmit5}
                nextStep={this.nextStep}
                prevStep={this.prevStep}
                values={this.state}
              />
            )}
          </SurveyWrapper>
        );
      case STEPS.FOURTH:
        const isFoundAdvisor = this.state.status === STATUS.FOUND_ADVISOR;
        return (
          <SurveyWrapper
            values={this.state}
            title={
              isFoundAdvisor
                ? "ADVISOR MATCH SERVICE FEEDBACK"
                : "Thank you for completing our survey.\nWe always value feedback."
            }
            showProgressBar={isFoundAdvisor}
            isThankYouPage={!isFoundAdvisor}
          >
            {isFoundAdvisor ? (
              <CustomerSatisfaction
                handleSubmit5={this.handleSubmit5}
                nextStep={this.nextStep}
                prevStep={this.prevStep}
                values={this.state}
              />
            ) : (
              <Thankyou values={this.state} />
            )}
          </SurveyWrapper>
        );
      case STEPS.FIFTH:
        return (
          <SurveyWrapper
            title="Thank you for completing our survey.\nWe always value feedback."
            showProgressBar={false}
            isThankYouPage={true}
          >
            <Thankyou values={this.state} />
          </SurveyWrapper>
        );
      default:
        return null;
    }
  }
}
